<template>
	<div>
		<!-- 编辑界面 -->
		<el-drawer :visible.sync="editFormVisible" :title="title" :size="600" class="margin_top_40" :wrapper-closable="false" :modal="false" :destroy-on-close="true" @click="closeDialog">
			<el-form ref="editForm" label-width="8.75rem" :model="editForm" :rules="rules" class="demo-form-inline" inline>
				<el-form-item label="组织名称" prop="name">
					<el-input clearable v-model="editForm.name" class="input_200px" size="small" auto-complete="off" placeholder="请输入组织名称"></el-input>
				</el-form-item>
				<el-form-item label="组织类型" prop="type">
					<el-select v-model="editForm.type" size="small" class="input_200px" placeholder="请选择组织类型">
						<el-option v-for="item in typeList" :key="item.code" :label="item.name" :value="Number(item.code)"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="负责人" prop="personInCharge">
					<el-select v-model="listPersonInCharge" size="small" class="input_200px" filterable multiple placeholder="请选择" @change="handleChange">
						<el-option v-for="item in peopleInCharge" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="区域经理" prop="remark10">
					<el-select v-model="listRemark10" size="small" class="input_200px" filterable clearable multiple placeholder="请选择区域经理" @change="handleRemarkChange('remark10', $event)">
						<el-option v-for="item in peopleInCharge" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="三级负责人" prop="remark9">
					<el-select v-model="listRemark9" size="small" class="input_200px" filterable clearable multiple placeholder="请选择三级负责人" @change="handleRemarkChange('remark9', $event)">
						<el-option v-for="item in peopleInCharge" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="四级负责人" prop="remark8">
					<el-select v-model="listRemark8" size="small" class="input_200px" filterable clearable multiple placeholder="请选择四级负责人" @change="handleRemarkChange('remark8', $event)">
						<el-option v-for="item in peopleInCharge" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="财务负责人" prop="remark7">
					<el-select v-model="listRemark7" size="small" class="input_200px" filterable clearable multiple placeholder="请选择财务负责人" @change="handleRemarkChange('remark7', $event)">
						<el-option v-for="item in peopleInCharge" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="联系电话" prop="remark1">
					<el-input clearable v-model="editForm.remark1" class="input_200px" size="small" auto-complete="off" placeholder="请输入联系电话"></el-input>
				</el-form-item>
				<el-form-item label="名称缩写" prop="remark2">
					<el-input clearable v-model="editForm.remark2" class="input_200px" size="small" auto-complete="off" placeholder="请输入名称缩写"></el-input>
				</el-form-item>
				<el-form-item label="组织描述" prop="descript">
					<el-input v-model="editForm.descript" class="input_200px" type="textarea" :rows="2" size="small" placeholder="请输入组织描述"></el-input>
				</el-form-item>
				<el-form-item label="是否门店">
					<el-switch v-model="editForm.isSet1" active-text="是" inactive-text="否"></el-switch>
				</el-form-item>
				<el-form-item label="是否工厂店">
					<el-switch v-model="editForm.isSet2" active-text="是" inactive-text="否"></el-switch>
				</el-form-item>
			</el-form>
			<div class="drawer-footer">
				<el-button size="small" icon="el-icon-check" :loading="saveloading" class="title" @click="submitForm('editForm')">保存</el-button>
				<el-button :disabled="editForm.keyId === ''" size="small" type="danger" icon="el-icon-delete" :loading="saveloading" class="title" @click="deleteMenu">删除</el-button>
			</div>
		</el-drawer>
	</div>
</template>
<script>
import { SaveOrganization, DelOrganization, GetOrganizationInfoDetail } from "../../../api/organizationalApi.js";
import { GetUserInfoDropList } from "../../../api/userApi.js";
import { GetEnumConfigListByCode } from "../../../api/enumApi.js";
export default {
	props: [],
	data() {
		return {
			saveloading: false,
			title: "",
			editFormVisible: false, //控制编辑页面显示与隐藏
			editForm: {
				keyId: "",
				name: "",
				type: 0,
				descript: "",
				parentId: "",
				personInCharge: "",
				remark1: "",
				remark2: "",
				remark7: "",
				remark8: "",
				remark9: "",
				remark10: "",
				isSet1: false,
				isSet2: false
			},
			listPersonInCharge: [],
			listRemark7: [],
			listRemark8: [],
			listRemark9: [],
			listRemark10: [],
			// rules表单验证
			rules: {
				name: [
					{
						required: true,
						message: "请输入组织名称",
						trigger: "blur"
					}
				]
			},
			peopleInCharge: [],
			typeList: []
		};
	},
	computed: {},
	watch: {},
	created() {},
	mounted() {},
	components: {},
	methods: {
		// 关闭编辑、增加弹出框
		closeDialog() {
			this.$refs["editForm"].resetFields();
			this.listPersonInCharge = [];
			this.listRemark7 = [];
			this.listRemark8 = [];
			this.listRemark9 = [];
			this.listRemark10 = [];
			this.editFormVisible = false;
		},

		//显示编辑界面
		editShow(row, type) {
			this.getPersonCharge();
			this.getEnumConfigListByCode();
			if (type === 1) {
				if (row != undefined && row != "undefined") {
					this.title = "编辑";
					this.getOrganizationInfoDetail(row.keyId);
				} else {
					this.title = "新增";
					this.$data.editForm = this.$options.data.call(this).editForm;
				}
			} else if (type === 2) {
				this.title = "新增";
				this.$data.editForm = this.$options.data.call(this).editForm;
				this.editForm.parentId = row.keyId;
			}
			this.editFormVisible = true;
		},

		// 编辑、增加页面保存方法
		submitForm(editData) {
			this.$refs[editData].validate((valid) => {
				if (valid) {
					this.editForm.personInCharge = this.listPersonInCharge.join(",");
					SaveOrganization(this.editForm)
						.then((res) => {
							this.loading = false;
							if (res.code === 1) {
								this.editFormVisible = false;
								this.$parent.getListData();
								this.$message({
									type: "success",
									message: "保存成功！"
								});
							} else {
								this.$message({
									type: "error",
									message: res.msg
								});
							}
						})
						.catch((err) => {
							this.loading = false;
							this.$message.error("保存失败，请稍后再试！");
						});
				} else {
					return false;
				}
			});
		},

		// 删除
		deleteMenu() {
			this.$confirm("确定要删除【" + this.editForm.name + "】吗?", "信息", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				let parmter = {
					keyId: this.editForm.keyId
				};
				DelOrganization(parmter)
					.then((res) => {
						if (res.code === 1) {
							this.$message({
								type: "success",
								message: "已删除!"
							});
							this.editFormVisible = false;
							this.$parent.getListData();
						} else {
							this.$message({
								type: "info",
								message: res.msg
							});
						}
					})
					.catch((err) => {
						this.loading = false;
						this.$message.error("删除失败，请稍后再试！");
					});
			});
		},

		// 获取人员
		getPersonCharge() {
			GetUserInfoDropList({})
				.then((res) => {
					this.peopleInCharge = res.data;
				})
				.catch((err) => {
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},

		// 获取枚举类型列表
		getEnumConfigListByCode() {
			let param = {
				code: "OrganizationType"
			};
			GetEnumConfigListByCode(param)
				.then((res) => {
					if (res.code == 1) {
						this.typeList = res.data;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},

		// 获取详情
		getOrganizationInfoDetail(key) {
			let param = {
				keyId: key
			};
			GetOrganizationInfoDetail(param)
				.then((res) => {
					if (res.code == 1) {
						this.editForm = res.data;
						this.listPersonInCharge = (res.data.personInCharge || "").split(",").filter(Boolean);
						this.listRemark10 = (res.data.remark10 || "").split(",").filter(Boolean);
						this.listRemark9 = (res.data.remark9 || "").split(",").filter(Boolean);
						this.listRemark8 = (res.data.remark8 || "").split(",").filter(Boolean);
						this.listRemark7 = (res.data.remark7 || "").split(",").filter(Boolean);
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},

		//负责人选中后事件
		handleChange(val) {
			if (val.length > 0) {
				this.editForm.personInCharge = val.join(",");
			} else {
				this.editForm.personInCharge = "";
			}
		},

		//岗位负责人(多个)选中后事件：把选中的 keyId 列表写入对应 remark 字段
		handleRemarkChange(field, val) {
			if (val && val.length > 0) {
				this.editForm[field] = val.join(",");
			} else {
				this.editForm[field] = "";
			}
		}
	}
};
</script>
<style scoped>
/deep/ .el-switch__core {
	width: 40px !important;
}
</style>
